import React from "react";
import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_construct-approve-1/artifacts/5rkws481_WhatsApp%20Image%202026-06-15%20at%2008.55.16.jpeg";

/**
 * Plan2Build brand logo.
 * - variant="image"  -> uses the bitmap logo (works best on white/light backgrounds)
 * - variant="word"   -> stylized "Plan2Build" wordmark (works on any background, the "2" is orange)
 * `to` (optional) wraps the logo in a <Link>. Pass `linkTo={null}` to render without a link.
 */
export default function Logo({
  variant = "word",
  className = "",
  height = 32,
  linkTo = "/",
  invert = false,
  withTagline = false,
  testId = "brand-logo",
}) {
  const inner =
    variant === "image" ? (
      <img
        src={LOGO_URL}
        alt="Plan2Build"
        style={{ height, width: "auto", display: "block" }}
        data-testid={testId}
      />
    ) : (
      <span
        className={`font-display font-extrabold tracking-tight leading-none ${className}`}
        style={{ fontSize: `${Math.round(height * 0.62)}px`, color: invert ? "#fff" : "var(--bq-navy)" }}
        data-testid={testId}
      >
        Plan<span style={{ color: "var(--bq-orange)" }}>2</span>Build
        {withTagline && (
          <span
            className="block font-sans font-normal mt-0.5 tracking-wide"
            style={{
              fontSize: `${Math.round(height * 0.22)}px`,
              color: invert ? "rgba(255,255,255,0.65)" : "var(--bq-text-muted)",
              letterSpacing: "0.04em",
            }}
          >
            Upload your plans. We build the rest.
          </span>
        )}
      </span>
    );

  if (linkTo == null) return inner;
  return (
    <Link to={linkTo} className="inline-flex items-center" data-testid={`${testId}-link`}>
      {inner}
    </Link>
  );
}
